(function () {
  function initAccordion() {
    document.querySelectorAll('.pac-trigger').forEach(btn => {
      if (btn.dataset.pacInit) return;
      btn.dataset.pacInit = 'true';
      btn.addEventListener('click', () => {
        const item = btn.closest('.pac-item');
        const isOpen = item.classList.contains('open');
        document.querySelectorAll('.pac-item').forEach(el => {
          el.classList.remove('open');
          el.querySelector('.pac-trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initAccordion);
  document.addEventListener('shopify:section:load', initAccordion);
})();
